<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box flex Flexjustify Flexalign">
      <div class="content">
        <div class="content_title mar_top_40">商品确认</div>
        <div class="goods_content mar_top_20">
          <div class="goods_content_top"></div>
          <div class="goods_content_box">
            <div class="goods_top flex Flexalign">
              <div class="goods_name Flexjustify flex Flexalign">课程名称</div>
              <div class="goods_empty Flexjustify flex flexcolumn"></div>
              <div class="goods_orgrnization">机构</div>
              <div class="goods_orgrnization">优惠券</div>
              <div class="goods_orgrnization">金额</div>
            </div>
            <div class="goods_top goods_info flex Flexalign" v-for="(item, index) in selectOrderList" :key="index">
              <div class="goods_name Flexjustify flex Flexalign">
                <el-image class="video_img" :src="imgPath(item.courseInfo?.courseCoverImg)"></el-image>
              </div>

              <div class="goods_empty goods_name_text Flexjustify flex flexcolumn">
                <div>{{ item.courseInfo?.courseName }}</div>
                <!-- 显示选中的规格信息 -->
                <div class="spec_info" v-if="item.spec && Object.keys(item.spec).length">
                  <span v-for="(value, key, idx) in item.spec" :key="idx">
                    {{ key }}：{{ value }}
                  </span>
                </div>
                <!-- <div class="goods_reward">购买课程最多可赠送30学分</div> -->
              </div>
              <div class="goods_orgrnization">
                {{ item.courseInfo?.shopName }}
              </div>
              <div class="goods_orgrnization">
                <el-select v-model="item.couponId" placeholder="请选择优惠券" no-data-text="暂无可用优惠券" size="large"
                  style="min-width: 100px" @visible-change="getUsableCouponList(item)" @change="getFinalPrice">
                  <el-option v-for="sitem in usableCouponList" :key="sitem.id" :label="sitem.couponName"
                    :value="sitem.id" :disabled="sitem.isSelected" />
                </el-select>
              </div>
              <div class="goods_orgrnization">
                ￥<span class="price_num">{{ getDisplayPrice(item) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="goods_content mar_top_30">
          <div class="goods_content_box">
            <div class="goods_content_box_top flex Flexalign FlexBetween">
              <div>用户名：{{ userInfo.name }}</div>
              <div class="flex Flexalign">
                <el-checkbox v-model="isReadAgreement" size="large" />
                <div class="mar_left_10 agree_text">
                  我已经阅读并确认签署<span class="active_color cursor_pointer"
                    @click="openAgreement('course_order_agreement')">《{{ agreementInfo.title }}》</span>
                </div>
              </div>
            </div>
            <div class="goods_content_box_bottom flex Flexalign FlexBetween mar_top_30">
              <div class="flex Flexalign">
                <div class="total_num">
                  共结算 {{ selectOrderList.length }} 件商品
                </div>
                <div class="price_text" @mouseenter="showPriceInfo" @mouseleave="hidePriceInfo">
                  价格明细
                  <div class="user_info_box flex flexcolumn Flexalign" v-if="isOpenPriceInfo">
                    <div class="flex Flexalign FlexBetween price_info_one">
                      <div>原价</div>
                      <div>¥{{ originalTotalPrice }}</div>
                    </div>
                    <div class="flex mar_top_30 Flexalign FlexBetween price_info_one">
                      <div>学分抵扣</div>
                      <div>¥0</div>
                    </div>
                    <div class="flex mar_top_30 Flexalign FlexBetween price_info_one">
                      <div>优惠券抵扣</div>
                      <div>
                        ¥{{ (originalTotalPrice - finalPrice).toFixed(2) }}
                      </div>
                    </div>
                    <div class="flex Flexalign FlexBetween price_info_one mar_top_20 flex-1 price_wait_pay">
                      <div>待支付</div>
                      <div>¥{{ finalPrice.toFixed(2) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex Flexalign">
                <div class="discount_value">
                  已优惠：¥{{ (originalTotalPrice - finalPrice).toFixed(2) }}
                </div>
                <div class="wait_pay">待支付：¥{{ finalPrice.toFixed(2) }}</div>
                <div class="flex Flexalign">
                  支付方式：<el-select v-model="payTypeValue" placeholder="Select" size="large" style="width: 100px">
                    <el-option v-for="item in pyeTypeOption" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </el-select>
                </div>
                <div class="btn_pay cursor_pointer mar_left_10" @click="payNow">
                  <div>立即支付</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <payDialog ref="payDialog"></payDialog>
    <agreement ref="agreement"></agreement>
  </moe-page>
</template>

<script>
import payDialog from "@/components/popup/payDialog.vue";
import { mapState } from "vuex";
import agreement from "@/components/popup/agreement.vue";

export default {
  name: "GjkcH5OrderConfirm",

  components: {
    payDialog,
    agreement,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },

  data() {
    return {
      isOpenPriceInfo: false,
      selectOrderList: [],
      originalTotalPrice: 0,
      carOrderInfo: {
        cartList: [],
        pointsNum: 0,
      },
      isReadAgreement: false,
      showPayTypeFlag: false,
      payTypeValue: 1,
      pyeTypeOption: [
        { label: "微信", value: 1 },
        { label: "支付宝", value: 2 },
      ],
      couponList: [],
      usableCouponList: [],
      finalPrice: 0,
      agreementInfo: {}
    };
  },

  mounted() {
    let type = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).type;
    if (type == 2) {
      this.getCarList();
    } else {
      let selectOrderList = this.$Jump.getUrlParams(
        window.location.hash.split("?")[1]
      ).selectOrderList;
      this.selectOrderList = JSON.parse(selectOrderList);
      this.initOrderList();
    }
    this.getCouponList();
    this.getAgreement();
  },

  methods: {
    /**
     * 获取商品显示价格（支持多规格）
     * @param {Object} item 订单商品项
     * @returns {Number} 价格
     */
    getDisplayPrice(item) {
      // 如果有多规格配置且规格不为空
      if (item.courseInfo?.styleSettingMode == 2 && item.spec && Object.keys(item.spec).length) {
        try {
          // 解析规格配置
          const specConfig = typeof item.courseInfo.specConfig === 'string'
            ? JSON.parse(item.courseInfo.specConfig)
            : item.courseInfo.specConfig;

          const skuList = specConfig.skuList || [];
          const currentSpec = item.spec;

          // 查找完全匹配的 SKU
          const matchedSku = skuList.find(sku => {
            const skuSpec = sku.spec;
            const specKeys = Object.keys(currentSpec);
            const skuSpecKeys = Object.keys(skuSpec);

            if (specKeys.length !== skuSpecKeys.length) {
              return false;
            }

            return specKeys.every(key => skuSpec[key] === currentSpec[key]);
          });

          // 如果找到匹配的 SKU，返回其价格
          if (matchedSku && typeof matchedSku.price !== 'undefined') {
            return matchedSku.price;
          }

          // 如果没有匹配的 SKU，使用原价格
          return item.coursePrice || item.courseInfo?.coursePrice || 0;

        } catch (error) {
          console.error('解析规格配置失败:', error);
          return item.coursePrice || item.courseInfo?.coursePrice || 0;
        }
      }

      // 单规格情况，直接返回课程价格
      return item.coursePrice || item.courseInfo?.coursePrice || 0;
    },

    /**
     * 获取商品价格数字（用于计算）
     * @param {Object} item 订单商品项
     * @returns {Number} 价格数字
     */
    getPriceNumber(item) {
      const price = this.getDisplayPrice(item);
      return typeof price === 'number' ? price : parseFloat(price) || 0;
    },

    /**
 * 初始化订单列表，计算价格和解析规格
 */
initOrderList() {
  let totalPrice = 0;
  
  this.selectOrderList.forEach((item) => {
    // 解析规格数据
    if (item.spec && typeof item.spec === 'string') {
      try {
        item.spec = JSON.parse(item.spec);
      } catch (e) {
        console.error('解析规格数据失败:', e);
        item.spec = {};
      }
    } else if (!item.spec) {
      item.spec = {};
    }
    
    // 获取商品价格
    const price = this.getPriceNumber(item);
    item.coursePrice = price;
    
    totalPrice += price;
    item.couponId = "";
  });
  
  // 保持为数字类型，不转字符串
  this.originalTotalPrice = totalPrice;
  this.finalPrice = totalPrice;
},

    getAgreement() {
      this.$Api.login.getAgreement('course_order_agreement').then(res => {
        this.agreementInfo = res.data.data;
      })
    },

    // 计算价格优惠等
getFinalPrice() {
  let totalPrice = 0;
  
  this.selectOrderList.forEach((item) => {
    const itemPrice = this.getPriceNumber(item);
    
    if (item.couponId) {
      let couponInfo = this.couponList.filter(
        (sitem) => sitem.id == item.couponId
      )[0];
      if (this.$Tools.empty(couponInfo)) {
        totalPrice += itemPrice;
        return;
      }
      
      if (couponInfo.couponType == 1) {
        // 满减券
        totalPrice += Number(
          Number(itemPrice) - couponInfo.reduceMoney >= 0
            ? (Number(itemPrice) - couponInfo.reduceMoney).toFixed(2)
            : 0
        );
      } else {
        // 折扣券
        totalPrice += Number(
          (Number(itemPrice) - (Number(itemPrice) * couponInfo.reduceMoney) / 10).toFixed(2)
        );
      }
    } else {
      totalPrice += itemPrice;
    }
  });
  
  // 保持为数字类型
  this.finalPrice = totalPrice;
},

    // 筛选可用优惠券
    getUsableCouponList(shopInfo) {
      // 筛选机构下优惠券
      this.usableCouponList = this.couponList.filter(
        (item) => item.shopId == shopInfo.shopId
      );
      if (this.$Tools.empty(this.couponList)) return;
      this.usableCouponList = this.couponList;
      // 判断时间（开始时间要小于当前时间）
      this.usableCouponList = this.usableCouponList.filter(item => {
        if (item.startTime) {
          let startTime = new Date(item.startTime).getTime();
          let nowTime = new Date().getTime();
          if (startTime <= nowTime) {
            return item
          }
        } else {
          return item
        }
      })
      
      // 获取商品价格用于满减判断
      const itemPrice = this.getPriceNumber(shopInfo);
      
      // 筛选满减条件满足的优惠券
      this.usableCouponList = this.usableCouponList.filter((item) => {
        if (item.couponType == 1) {
          if (item.fullMoney <= itemPrice) {
            return item;
          } else {
            return;
          }
        } else {
          return item;
        }
      });
      
      // 先遍历如果是已选的优惠券那么设置isSelected为true，禁用该优惠券选择不展示
      this.selectOrderList.forEach((item) => {
        this.usableCouponList.forEach((sitem) => {
          if (item.couponId == sitem.id) {
            sitem.isSelected = true;
          } else {
            sitem.isSelected = false;
          }
        });
      });
      
      // 筛选出可选的优惠券列表
      this.usableCouponList = this.usableCouponList.filter(
        (item) => item.isSelected == false
      );
      return this.usableCouponList;
    },

    // 获取优惠券列表
    getCouponList() {
      let listQuery = {
        page: 1,
        pageSize: 9999,
        shopId: "",
        applyType: 4,
        state: 0,
      };
      this.$Api.shop
        .getCouponList(listQuery)
        .then((res) => {
          this.couponList = res.data.data.list.map((item) => {
            return { ...item, isSelected: false };
          });
          this.$forceUpdate();
        })
        .catch(() => { });
    },

    showPayType() {
      this.showPayTypeFlag = true;
    },

    hidePayType() {
      this.showPayTypeFlag = false;
    },

    // 协议弹窗
    openAgreement(type) {
      this.$refs.agreement.agreementShow = true;
      this.$refs.agreement.type = type;
      this.$refs.agreement.getAgreement();
    },

    // 获取购物车列表（立即购买场景）
    getCarList() {
      this.$Api.shop
        .getCarList({ type: 2 })
        .then((res) => {
          this.selectOrderList = res.data.data;
          this.initOrderList();
        })
        .catch(() => { });
    },

    // 价格明细
    showPriceInfo() {
      this.isOpenPriceInfo = true;
    },

    hidePriceInfo() {
      this.isOpenPriceInfo = false;
    },

    payNow() {
      this.carOrderInfo = {
        cartList: [],
        pointsNum: 0,
      };
      this.selectOrderList.forEach((item) => {
        this.carOrderInfo.cartList.push({
          cartId: item.cartId,
          couponId: item.couponId,
        });
      });
      this.placeOrder();
    },

    // 下单
    placeOrder() {
      if (!this.isReadAgreement) {
        this.$Dialog.confirm({
          message: "请先阅读确认冠军高考专家辅导课购买协议",
          title: "警告",
          onConfirm: () => {
            this.isReadAgreement = true;
            this.placeOrder();
          },
          onCancel: () => {
            // console.log("取消支付");
          },
        });
        return;
      }
      
      this.loading = this.$loading({
        lock: true,
        text: `正在为您下单`,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      
      this.$Api.course
        .placeOrder(this.carOrderInfo)
        .then((res) => {
          this.loading.close();
          this.$Dialog.confirm({
            message: "是否立即付款",
            title: "警告",
            onConfirm: () => {
              this.payOrder(res.data.data.orderParentId);
              this.$refs.payDialog.orderId = res.data.data.orderParentNo;
            },
            onCancel: () => {
              console.log("取消支付");
              this.$Jump.href("/orderList");
            },
          });
        })
        .catch(() => { });
    },

    payOrder(orderParentId) {
      this.loading = this.$loading({
        lock: true,
        text: `正在进行支付`,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      
      this.$Api.shop
        .getPayQrcode({
          orderPayType: this.payTypeValue,
          parentId: orderParentId,
          qrcodeWidth: 180,
        })
        .then((res) => {
          this.loading.close();
          this.$refs.payDialog.unbindShow = true;
          this.$refs.payDialog.qrCodeValue = res.data.data.codeUrl;
          this.$refs.payDialog.orinceTotalPrice = this.finalPrice;
          this.$refs.payDialog.payType = this.payTypeValue;
          this.$refs.payDialog.parentId = orderParentId;
          setTimeout(() => {
            this.$refs.payDialog.startInterval();
          }, 800);
        })
        .catch(() => {
          this.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .content {
    width: $pageMainWidth;
    min-height: calc(100vh - $pageTopHeight);

    .content_title {
      font-weight: bold;
      font-size: 22px;
      color: #2e3d56;

      .integral_attention {
        font-size: 16px;
        color: #666666;
      }
    }

    .goods_content {
      width: $pageMainWidth;
      border-radius: 10px;
      background: #ffffff;

      .goods_content_top {
        width: $pageMainWidth;
        height: 6px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 10px 10px 0 0;
      }

      .goods_content_box {
        padding: 0 20px;

        .goods_top {
          padding: 20px 0;
          box-sizing: border-box;
          text-align: center;
          color: #333333;
          border-bottom: 1px solid rgba(20, 20, 20, 0.1);

          .goods_name {
            width: 22%;
          }

          .goods_empty {
            width: 28%;
            text-align: left;
            height: 20px;
          }

          .goods_name_text {
            height: 120px;

            .spec_info {
              font-size: 12px;
              color: #999;
              margin-top: 5px;

              span {
                margin-right: 10px;
              }
            }

            .goods_reward {
              margin-top: 15px;
              color: #deae55;
              font-size: 16px;
            }
          }

          .goods_orgrnization {
            width: 25%;
          }

          .video_img {
            width: 200px;
            height: 112px;
          }
          
          .price_num {
            font-size: 18px;
            font-weight: bold;
            color: #ff6619;
          }
        }

        .goods_info {
          font-size: 18px;
        }

        .goods_content_box_left {
          height: 140px;

          .integral_used {
            font-weight: bold;
            font-size: 20px;
            color: #333333;
          }

          .integral_input {
            margin: 0 35px;
            color: #333333;
            font-weight: 600;

            :deep(.el-input__wrapper) {
              box-shadow: none;
              border-bottom: 1px solid #2e3d56;
              border-radius: 0;
            }
          }

          .coupon_input {
            margin-left: 35px;
          }
        }

        .btn_use {
          width: 150px;
          height: 48px;
          background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
          border-radius: 24px;
          font-size: 18px;
          color: #ffffff;
          line-height: 48px;
          text-align: center;
        }

        .goods_content_box_top {
          width: 100%;
          font-size: 18px;
          padding-top: 30px;

          :deep(.el-checkbox.el-checkbox--large .el-checkbox__inner) {
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }

          :deep(.el-checkbox__inner::after) {
            left: 8px;
            top: 8px;
          }

          .agree_text {
            color: #666666;
          }

          .active_color {
            color: RGBA(82, 225, 193, 1);
          }
        }

        .goods_content_box_bottom {
          padding-bottom: 30px;

          .total_num {
            font-weight: bold;
            font-size: 22px;
            color: #2e3d56;
          }

          .price_text {
            font-size: 20px;
            color: #666666;
            margin-left: 20px;
            padding-bottom: 5px;
            border-bottom: 1px solid #666666;
            position: relative;

            .user_info_box {
              top: -230px;
              right: -230px;
              position: absolute;
              width: 242px;
              height: 224px;
              background: #ffffff;
              box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
              border-radius: 10px;
              font-size: 14px;
              color: #666666;
              line-height: 29px;
              padding: 25px 15px;
              font-size: 18px;
              color: #333333;

              .price_info_one {
                width: 100%;
              }

              .price_wait_pay {
                color: #ff7a24;
                border-top: 1px solid rgba(36, 35, 36, 0.1);
                padding-top: 20px;
                box-sizing: border-box;
              }
            }
          }

          .discount_value {
            font-size: 18px;
            color: #333333;
          }

          .wait_pay {
            font-size: 18px;
            color: #ff7a24;
            margin: 0 25px;
          }

          .btn_pay {
            width: 200px;
            height: 48px;
            background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
            border-radius: 24px;
            font-size: 18px;
            color: #ffffff;
            text-align: center;
            line-height: 48px;
            position: relative;
          }
        }
      }
    }
  }
}

:deep(.el-checkbox.el-checkbox--large .el-checkbox__inner) {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

:deep(.el-checkbox__inner::after) {
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  left: 8px;
  top: 6px;
  height: 10px;
  width: 5px;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background: linear-gradient(90deg, #00d5c2, #00d498);
  border-color: #00d498;
}
</style>